import { render, staticRenderFns } from "./ExtensionAndProformListTable.vue?vue&type=template&id=7b129a6f&scoped=true&lang=pug&"
import script from "./ExtensionAndProformListTable.vue?vue&type=script&lang=ts&"
export * from "./ExtensionAndProformListTable.vue?vue&type=script&lang=ts&"
import style0 from "./ExtensionAndProformListTable.vue?vue&type=style&index=0&id=7b129a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b129a6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
